// Standard easings.net easeInCirc.
export const easeInCirc = 'cubic-bezier(0.55, 0, 1, 0.45)';
